// @tts-nocheck

//import $ from 'jquery';
import * as SurveyReact from 'survey-react';

const WIDGET_NAME = 'geolocation';
const WIDGET_TITLE = 'Geo Location';
const WIDGET_LOGGING = process.env.NODE_ENV !== 'production';
const DEFAULT_LOCATION_ACCURACY = 10;
const POSITION_TIMEOUT = 10; // seconds
//const WIDGET_CLASSPREFIX = 'geo-location-widget-'

type WidgetValueType = {
  latitude: number;
  longitude: number;
  altitude?: number;
  accuracy?: number;
  address: string;
};

type CoordType = {
  lat: number;
  lng: number;
};

const DefaultWidgetValue: WidgetValueType = {
  latitude: -26.1708687,
  longitude: 27.9901695,
  altitude: undefined,
  accuracy: undefined,
  address: '',
};

const equalValues = (a: WidgetValueType | undefined | null, b: WidgetValueType | undefined | null): boolean => {
  if (!a && !b) return true;
  if (!a && !!b) return false;
  if (!!a && !b) return false;
  if (!!a && !!b && a.latitude === b.latitude && a.longitude === b.longitude) return true;
  return false;
};

const convertToCoord = (value: string): CoordType | null => {
  if (!value) return null;
  const parts = value.split(',');
  if (parts.length !== 2) return null;
  const coord: CoordType = {
    lat: parseFloat(parts[0]),
    lng: parseFloat(parts[1]),
  };
  if (isNaN(coord.lat) || isNaN(coord.lng)) return null;
  return coord;
};

const convertDecimalToDMS = (decimal: number): string => {
  var degrees = Math.floor(decimal);
  var minutesDecimal = (decimal - degrees) * 60;
  var minutes = Math.floor(minutesDecimal);
  var seconds = Math.round((minutesDecimal - minutes) * 60);

  return degrees + '°' + minutes + "'" + seconds + '"';
};

const convertCoordinatesDecimalToDMS = (latitude: number, longitude: number): string => {
  return (
    (latitude < 0 ? 'S ' : 'N ') +
    convertDecimalToDMS(Math.abs(latitude)) +
    ', ' +
    (longitude < 0 ? 'W ' : 'E ') +
    convertDecimalToDMS(Math.abs(longitude))
  );
};

const init = (Survey: any, $: any) => {
  const widget = {
    name: WIDGET_NAME,

    title: WIDGET_TITLE,

    iconName: '',

    widgetIsLoaded: function() {
      return true;
    },

    isFit: function(question: any) {
      return question.getType() === WIDGET_NAME;
    },

    activatedByChanged: function(activatedBy: any) {
      Survey.Serializer.addClass(WIDGET_NAME, [], null, 'empty');

      const properties: any[] = [
        {
          name: 'height',
          default: '500px',
        },
        {
          name: 'defaultToCurrentLocation',
          displayName: 'Default to Current Location',
          type: 'boolean',
          category: 'general',
          default: true,
        },
        {
          name: 'currentLocationAccuracy',
          displayName: 'Current Location Accuracy (m)',
          type: 'number',
          category: 'general',
          default: DEFAULT_LOCATION_ACCURACY,
        },
        {
          name: 'enableSetToCurrentLocation',
          displayName: 'Enable "Set To Current Location" button',
          type: 'boolean',
          category: 'general',
          default: true,
        },
        {
          name: 'allowAddressChange',
          displayName: 'Enable Address Input',
          type: 'boolean',
          category: 'general',
          default: false,
        },
        {
          name: 'allowMarkerChange',
          displayName: 'Enable Map Marker Change',
          type: 'boolean',
          category: 'general',
          default: false,
        },
        {
          name: 'allowPinDrop',
          displayName: 'Enable Pin Drop',
          type: 'boolean',
          category: 'general',
          default: false,
        },
        {
          name: 'restrictTopLeftLocation',
          displayName: 'Top Left Coordinates (lat,lng)',
          type: 'string',
          category: 'Geolocation',
          categoryIndex: 50,
        },
        {
          name: 'restrictBottomRightLocation',
          displayName: 'Bottom Right Coordinates (lat,lng)',
          type: 'string',
          category: 'Geolocation',
          categoryIndex: 50,
        },
      ];

      Survey.Serializer.addProperties(WIDGET_NAME, properties);

      Survey.JsonObject.metaData.addClass(WIDGET_NAME, [], null, 'text');
      Survey.JsonObject.metaData.addProperties(WIDGET_NAME, properties);

      const hideProperty = (name: string) => {
        const prop = Survey.JsonObject.metaData.getProperty(WIDGET_NAME, name);
        if (!!prop) prop.visible = false;
      };
      hideProperty('requirePhotos');
      hideProperty('inputType');
      hideProperty('size');
      hideProperty('textUpdateMode');
      hideProperty('autoComplete');
      hideProperty('maxLength');
      hideProperty('placeHolder');
      hideProperty('dataList');
      hideProperty('autoUnmask');
      hideProperty('clearIncomplete');
      hideProperty('inputFormat');
      hideProperty('inputMask');
      hideProperty('numericDigits');
      hideProperty('options');
      hideProperty('prefix');
      hideProperty('suffix');
    },

    isDefaultRender: false,

    htmlTemplate: `
      <div class="geo-location-widget-widget">
        <div class="geo-location-widget-card">
          <div class="geo-location-widget-button-container" style="margin-top: 5px; text-align: center;">
            <button class="geo-location-widget-button sv-btn sv-matrixdynamic__add-btn" type="button">Set to current location</button>
          </div>
          <div class="geo-location-widget-input-container" style="margin-top: 5px;">
            <input class="geo-location-widget-input" type="text" placeholder="Enter a location" style="width: 100%;">
          </div>
          <div class="geo-location-widget-info-container" style="margin-top: 10px; margin-bottom: 10px; text-align: center;">
            <span class="geo-location-widget-info-coordinates-label">Coordinates: </span><span class="geo-location-widget-info-coordinates-value"></span><br/>
            <span class="geo-location-widget-info-altitude-label">Altitude: </span><span class="geo-location-widget-info-altitude-value"></span><br/>
            <span class="geo-location-widget-info-accuracy-label">Accuracy: </span><span class="geo-location-widget-info-accuracy-value"></span><span class="geo-location-widget-message" style="margin-left: 10px;"></span>
          </div>
        </div>
        <div>
          <div class="geo-location-widget-map" style="height: 400px;></div>
          <div class="geo-location-widget-infowindow-content">
            <img src="" width="16" height="16" id="place-icon">
            <span id="place-name"  class="title"></span><br>
            <span id="place-address"></span>
        </div>
    </div>
      </div>
    `,

    afterRender: function(question: SurveyReact.Question, element: HTMLElement) {
      var valueInternalChange = false;
      var watchPositionId: number | undefined = undefined;
      var watchTimeoutId: number | undefined = undefined;

      const defaultToCurrentLocation: boolean = question.getPropertyValue('defaultToCurrentLocation');
      var currentLocationAccuracy: number = parseInt(question.getPropertyValue('currentLocationAccuracy'));
      currentLocationAccuracy = isNaN(currentLocationAccuracy) ? DEFAULT_LOCATION_ACCURACY : currentLocationAccuracy;
      const enableSetToCurrentLocation: boolean = question.getPropertyValue('enableSetToCurrentLocation');
      const allowAddressChange: boolean = question.getPropertyValue('allowAddressChange') && !question.isReadOnly;
      const allowMarkerChange: boolean = question.getPropertyValue('allowMarkerChange') && !question.isReadOnly;
      const allowPinDrop: boolean = question.getPropertyValue('allowPinDrop') && !question.isReadOnly;
      const restrictTopLeftCoords: CoordType | null = convertToCoord(
        question.getPropertyValue('restrictTopLeftLocation') || ''
      );
      const restrictBottomRightCoords: CoordType | null = convertToCoord(
        question.getPropertyValue('restrictBottomRightLocation') || ''
      );

      var $root = $(element);
      var $map = $root.find('.geo-location-widget-map');
      var message: HTMLSpanElement = $root.find('.geo-location-widget-message')[0] as HTMLSpanElement;
      var $setToCurrentLocationButton = $root.find('.geo-location-widget-button-container');
      var input: HTMLInputElement = $root.find('.geo-location-widget-input')[0];
      var locationElements = {
        coordinates: $root.find('.geo-location-widget-info-coordinates-value')[0] as HTMLSpanElement,
        altitude: $root.find('.geo-location-widget-info-altitude-value')[0] as HTMLSpanElement,
        accuracy: $root.find('.geo-location-widget-info-accuracy-value')[0] as HTMLSpanElement,
      };

      const locationOutOfBounds = (location: CoordType | undefined | null, showMessage?: boolean): boolean => {
        if (location === undefined || location === null || isNaN(location.lat) || isNaN(location.lng)) return false;
        if (!restrictTopLeftCoords || !restrictBottomRightCoords) return false;
        const outOfBonunds = !(
          restrictBottomRightCoords.lat <= location.lat &&
          location.lat <= restrictTopLeftCoords.lat &&
          restrictTopLeftCoords.lng <= location.lng &&
          location.lng <= restrictBottomRightCoords.lng
        );
        if (outOfBonunds && !!showMessage) {
          alert('Location out of bounds.');
        }
        return outOfBonunds;
      };

      const setQuestionValue = (
        value: WidgetValueType | undefined | null,
        options?: {
          completeData?: boolean;
          dontClearMessage?: boolean;
          dontUpdateAddressInputIfAddressBlank?: boolean;
        }
      ) => {
        const _options = {
          ...{
            completeData: false,
            dontClearMessage: true,
            dontUpdateAddressInputIfAddressBlank: !!value && !!value.address,
          },
          ...(options || {}),
        };

        const fetchAddress = (value: WidgetValueType) => {
          return new Promise((resolve, reject) => {
            if (!!value.address) {
              resolve(value);
            } else {
              geocoder
                .geocode({
                  location: {
                    lat: value.latitude,
                    lng: value.longitude,
                  },
                })
                .then((response: any) => {
                  if (response && response.results && response.results.length > 0) {
                    value.address = response.results[0].formatted_address;
                    if (WIDGET_LOGGING) console.log('GeoLocationWidget', 'setQuestionValue:address', value);
                    resolve(value);
                  }
                })
                .catch((error: any) => {
                  console.error('GeoLocationWidth:setQuestionValue:fetchAddress failed', error);
                  reject('failed');
                });
            }
          });
        };

        const fetchAltitude = (value: WidgetValueType) => {
          return new Promise((resolve, reject) => {
            if (value.altitude !== undefined && value.altitude !== null) {
              resolve(value);
            } else {
              elevationService
                .getElevationForLocations({
                  locations: [{ lat: value.latitude, lng: value.longitude }],
                })
                .then((response: any) => {
                  if (response && response.results && response.results.length > 0) {
                    value.altitude = response.results[0].elevation;
                    if (WIDGET_LOGGING) console.log('GeoLocationWidget', 'setQuestionValue:elevation', value);
                  }
                  resolve(value);
                })
                .catch((error: any) => {
                  console.error('GeoLocationWidth:setQuestionValue:fetchAltitude failed', error);
                  reject('failed');
                });
            }
          });
        };

        if (WIDGET_LOGGING) console.log('GeoLocationWidget', 'setQuestionValue', value, options);
        if (!value) {
          question.value = '';
          if (!_options.dontClearMessage) message.textContent = '';
        } else {
          if (value.accuracy === 0 && !_options.dontClearMessage) message.textContent = '';
          if (!_options.completeData) {
            question.value = JSON.stringify(value);
          } else {
            if (value.altitude === undefined || value.altitude === null || !value.address) {
              fetchAltitude(value).then((v: any) => {
                fetchAddress(v as WidgetValueType).then((v: any) => {
                  const value = v as WidgetValueType;
                  question.value = JSON.stringify(value);
                  if (!_options.dontUpdateAddressInputIfAddressBlank) {
                    input.value = value.address;
                  }
                });
              });
            }
          }
        }
      };

      const getQuestionValue = (): WidgetValueType | undefined => {
        const value = question.value;
        if (!value) return undefined;
        try {
          return JSON.parse(value) as WidgetValueType;
        } catch (error) {
          return value as WidgetValueType;
        }
      };

      const updateLocationValues = () => {
        if (!locationElements.coordinates) return;
        const value = getQuestionValue();
        if (!value) {
          locationElements.coordinates.textContent = '';
          locationElements.altitude.textContent = '';
          locationElements.accuracy.textContent = '';
        } else {
          locationElements.coordinates.textContent = convertCoordinatesDecimalToDMS(value.latitude, value.longitude);
          locationElements.altitude.textContent = value.altitude === undefined ? '' : `${Math.round(value.altitude)}m`;
          locationElements.accuracy.textContent =
            value.accuracy === undefined ? '' : `${Math.round(value.accuracy)}m (target < ${currentLocationAccuracy}m)`;
        }
      };

      const currentPositionSuccess = (pos: any) => {
        if (WIDGET_LOGGING) console.log('geolocation', pos);
        if (
          locationOutOfBounds(
            {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            },
            true
          )
        )
          return;
        if (pos.coords.accuracy <= currentLocationAccuracy) {
          clearCurrentLocationId();
          message.textContent = '';
          setQuestionValue(
            {
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
              altitude: pos.coords.altitude === null ? undefined : pos.coords.altitude,
              accuracy: pos.coords.accuracy,
              address: '',
            },
            { completeData: true }
          );
          if (enableSetToCurrentLocation) $setToCurrentLocationButton.prop('disabled', false);
        } else {
          message.textContent = message.textContent + '.';
          setQuestionValue(
            {
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
              altitude: pos.coords.altitude === null ? undefined : pos.coords.altitude,
              accuracy: pos.coords.accuracy,
              address: '',
            },
            { completeData: false }
          );
        }
      };

      const currentPositionError = (err: any) => {
        message.textContent = 'Error retrieving current location.';
        console.error(err.message);
        clearCurrentLocationId();
      };

      const clearCurrentLocationId = () => {
        if (watchPositionId !== undefined) navigator.geolocation.clearWatch(watchPositionId);
        if (watchTimeoutId !== undefined) clearTimeout(watchTimeoutId);
        watchPositionId = undefined;
        watchTimeoutId = undefined;
      };

      const retrieveCurrentLocation = () => {
        clearCurrentLocationId();
        message.textContent = `Retrieving current location.`;
        watchPositionId = navigator.geolocation.watchPosition(currentPositionSuccess, currentPositionError, {
          enableHighAccuracy: true,
          maximumAge: 2000,
          timeout: POSITION_TIMEOUT * 1000,
        });
        watchTimeoutId = window.setTimeout(() => {
          if (WIDGET_LOGGING) console.log('geolocation timeout');
          if (enableSetToCurrentLocation) $setToCurrentLocationButton.prop('disabled', false);
          clearCurrentLocationId();
          const value = getQuestionValue();
          if (!value || value.accuracy === undefined || value.accuracy > currentLocationAccuracy) {
            message.textContent = 'Unable to determine a more accurate location.';
          } else {
            message.textContent = '';
          }
          setQuestionValue(value, { completeData: true });
        }, POSITION_TIMEOUT * 1000);
      };

      if (!question.isDesignMode && !question.isReadOnly) {
        if (defaultToCurrentLocation) retrieveCurrentLocation();
      }

      if (!enableSetToCurrentLocation) {
        $setToCurrentLocationButton.hide();
      } else if (!question.isDesignMode && !question.isReadOnly) {
        $setToCurrentLocationButton.click(() => {
          $setToCurrentLocationButton.prop('disabled', true);
          retrieveCurrentLocation();
        });
      }

      const googleMaps: any = window['google'] !== undefined ? window['google'].maps : {};
      var mapCenter: CoordType = { lat: DefaultWidgetValue.latitude, lng: DefaultWidgetValue.longitude };
      if (!!restrictBottomRightCoords && !!restrictTopLeftCoords) {
        mapCenter = {
          lat: restrictTopLeftCoords.lat + (restrictBottomRightCoords.lat - restrictTopLeftCoords.lat) / 2.0,
          lng: restrictTopLeftCoords.lng + (restrictBottomRightCoords.lng - restrictTopLeftCoords.lng) / 2.0,
        };
      }
      var value: WidgetValueType | undefined = undefined;
      if (question.isReadOnly) {
        value = getQuestionValue();
        if (value) mapCenter = { lat: value.latitude, lng: value.longitude };
      } else {
        question.value = '';
      }

      const geocoder = new googleMaps.Geocoder();
      const elevationService = new googleMaps.ElevationService();
      var map = new googleMaps.Map($map[0], {
        center: mapCenter,
        zoom: 13,
        ...(!!restrictBottomRightCoords && !!restrictTopLeftCoords
          ? {
              restriction: {
                latLngBounds: {
                  north: restrictTopLeftCoords.lat,
                  south: restrictBottomRightCoords.lat,
                  west: restrictTopLeftCoords.lng,
                  east: restrictBottomRightCoords.lng,
                },
                strictBounds: false,
              },
            }
          : {}),
      });
      if (!allowAddressChange) {
        input.placeholder = '';
        input.readOnly = true;
      }

      var marker = new googleMaps.Marker({
        map: map,
        anchorPoint: new googleMaps.Point(0, -29),
      });

      var autocomplete =
        allowAddressChange && !question.isReadOnly ? new googleMaps.places.Autocomplete(input) : undefined;

      const autoCompletePlaceChanged = () => {
        marker.setVisible(false);
        const place = autocomplete.getPlace();
        if (!place.geometry || !place.geometry.location) {
          // User entered the name of a Place that was not suggested and pressed the Enter key, or the Place Details request failed.
          console.warn("No details available for input: '" + place.name + "'");
          return;
        }

        if (locationOutOfBounds({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() }, true)) {
          input.value = '';
          return;
        }
        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
          map.setZoom(17); // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setDraggable(allowMarkerChange);
        marker.setVisible(true);

        setQuestionValue(
          {
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
            altitude: undefined,
            accuracy: 0,
            address: place.formatted_address,
          },
          { completeData: true }
        );
      };

      const mapClick = (event: any) => {
        if (!marker) return;
        const latLng = event.latLng;
        marker.setPosition(latLng);
        marker.setDraggable(allowMarkerChange);
        marker.setVisible(true);
        setQuestionValue(
          {
            latitude: latLng.lat(),
            longitude: latLng.lng(),
            altitude: undefined,
            accuracy: 0,
            address: '',
          },
          { completeData: true }
        );
      };

      const markerDragEnd = () => {
        if (!marker) return;
        const newValue: WidgetValueType = {
          latitude: marker.getPosition().lat(),
          longitude: marker.getPosition().lng(),
          altitude: undefined,
          accuracy: 0,
          address: '',
        };
        const currentValue = getQuestionValue();
        if (WIDGET_LOGGING)
          console.log('GeoLocationWidget', 'markerDragEnd', valueInternalChange, currentValue, newValue);
        if (valueInternalChange || equalValues(currentValue, newValue)) return;
        valueInternalChange = true;
        setQuestionValue(newValue, { completeData: true });
        valueInternalChange = false;
      };

      if (!question.isReadOnly) {
        if (allowMarkerChange) marker.addListener('dragend', markerDragEnd);
        if (allowPinDrop) map.addListener('click', mapClick);
      }

      if (!!autocomplete) {
        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo('bounds', map);
        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(['formatted_address', 'geometry', 'name']);
        autocomplete.addListener('place_changed', autoCompletePlaceChanged);
      }

      question.valueChangedCallback = function() {
        const value = getQuestionValue();
        updateLocationValues();
        if (WIDGET_LOGGING) console.log('GeoLocationWidget', 'valueChangedCallback', valueInternalChange, value);
        if (valueInternalChange) return;
        if (!value) {
          marker.setVisible(false);
        } else {
          map.setCenter({
            lat: value.latitude,
            lng: value.longitude,
          });
          map.setZoom(17);
          marker.setPosition({
            lat: value.latitude,
            lng: value.longitude,
          });
          marker.setDraggable(allowMarkerChange);
          marker.setVisible(true);
        }
      };

      if (question.isReadOnly && !!value) {
        marker.setPosition({
          lat: value.latitude,
          lng: value.longitude,
        });
        marker.setVisible(true);
        map.setZoom(17);
        input.value = value.address || '';
      }
    },

    willUnmount: function(question: any, element: any) {},
  };

  if (!!Survey) {
    Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
  }
};

const widget = {
  init,
  name: WIDGET_NAME,
};

export default widget;
